import Cache from "c-cache";
import PbAjax from "up-pbajax";
import notification from "c-notification";
import { execute } from "@js/base/tools";
import global from "@js/base/global";
import publicpb from "../../base/public.pb";
import indexpb from "./visitor.pb";
import lang from "../../lang/index";
import Url from "c-url";
import sendTicket from "@js/component/TD/sendTicket";

const cache = new Cache({
  prefix: "uplive",
});

let pbajax = new PbAjax();
// let F5MaxCount = 0;
// let timer = 300;

// const sleep = function(time){
//     return new Promise(function(resolve){
//       setTimeout(resolve, time);
//     });
// }
// const getF5Init = function(time){
//     return window.__xr_uplive && window.__xr_uplive();
// }
let visitor = {
  // // 监听F5初始化
  // F5Init() {
  //     sleep(timer).then(()=>{
  //         if (!getF5Init() && F5MaxCount <= 5) {
  //             timer = 400;
  //             F5MaxCount ++
  //             visitor.F5Init()
  //             return false;
  //         }
  //         visitor.register();
  //     })
  // },
  async register() {
    let self = this;
    const reCaptchaToken = await execute("visitorRegister");
    let _lang = lang.type;
    let countryCode = _lang.split("-")[1].toUpperCase() || "US";
    let businessData = new indexpb.Visitor.RegisterH5.Request({
      countryCode,
      tdBx: window.tdBlackBox,
      riskCheckParam: { reCaptchaToken },
      blackBox: {
        tdBox: window.tdBlackBox,
        tkid: window.tkid,
      },
    });
    let feature = Url.query("feature") || 0;
    let deviceId;
    let cacheDeviceId = cache.getCache("smDeviceId");

    if (cacheDeviceId) {
      //缓存用户数美的标识别
      deviceId = cacheDeviceId;
    } else {
      deviceId = SMSdk.getDeviceId();
      cache.setCache("smDeviceId", deviceId);
    }

    let defer = $.Deferred();

    pbajax.do(
      {
        service: "account",
        api: "/visitor/register/h5",
        header: {
          UserAgent: `${global.getGlobalUA()} feature/${feature}`,
        },
      },
      businessData,
      function (res) {
        let dataWrap = publicpb.Result.decode(res);
        let data;

        if (dataWrap.code == 1) {
          data = indexpb.Visitor.RegisterH5.Response.decode(
            dataWrap.data.value
          );

          let userInfo = Object.assign(
            {},
            data.profile,
            self.parseData(data.profile)
          );

          cache.setCache("user", {
            uid: userInfo.uid,
            userToken: userInfo.userToken,
            subscribe: userInfo.subscribe,
          });
          sendTicket({ key: userInfo.uid, value: window.tkid });
          $.channel.emit("registerVisitorSuccess", userInfo);

          defer.resolve(userInfo);
        } else {
          $.channel.emit("login");
          defer.reject();
        }
      },
      () => {
        $.channel.emit("login");

        defer.reject();
      },
      () => {
        $.channel.emit("login");

        defer.reject();
      }
    );
  },
  /*
   * 解析数据
   */
  parseData(data) {
    let balance = data.balance || {};

    return {
      uid: this.longToString(data.uid), // 用户UID
      balance: {
        diamond: this.longToInt(balance.diamond),
        bill: this.longToInt(balance.bill),
        inBill: this.longToInt(balance.inBill),
        outDiamond: this.longToInt(balance.outDiamond),
      },
      exp: this.longToInt(data.exp), // 用户经验值
      currentExp: this.longToInt(data.currentExp), //当前级的经验值
      nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
      chatroomid: this.longToString(data.chatroomid),
      officialAuth: data.officialAuth || 0, // 大V认证标识 1是 0否
    };
  },

  longToString(value) {
    return window.longToString(value);
  },

  longToInt(value) {
    value = this.longToString(value);

    return parseInt(value, 10) || 0;
  },
};

export default visitor;



// WEBPACK FOOTER //
// ./js/component/visitor/index.js